import { createSelector } from 'reselect';
import { mapWithDefault, toJs } from '../../../utils/dataMapper';

const selectStepOtherStarr = (state) => state.get('stepOtherStarr');

const makeSelectStepOtherStarr = () => createSelector(
  selectStepOtherStarr,
  (stepOtherStarrState) => ({
    isThereAnyThingElseYouWouldLikeToClaimFor: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'isThereAnyThingElseYouWouldLikeToClaimFor']), ''),
    areYouClaimingForPersonalLiability: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'areYouClaimingForPersonalLiability']), ''),
    areYouClaimingForGolfPackOptionalCover: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'areYouClaimingForGolfPackOptionalCover']), ''),
    areYouClaimingForBicyclePackOptionalCover: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'areYouClaimingForBicyclePackOptionalCover']), ''),
    areYouClaimingForAccidentalDeathAndDismemberment: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'areYouClaimingForAccidentalDeathAndDismemberment']), ''),
    areYouClaimingForRepatriationExpenses: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'areYouClaimingForRepatriationExpenses']), ''),
    areYouClaimingForBurialExpenses: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'areYouClaimingForBurialExpenses']), ''),
    personalLiabilitiesClaimDetail: mapWithDefault(stepOtherStarrState, () => toJs(stepOtherStarrState.getIn(['form', 'personalLiabilitiesClaimDetail'])), ''),
    golfPackOptionalClaimDetail: mapWithDefault(stepOtherStarrState, () => toJs(stepOtherStarrState.getIn(['form', 'golfPackOptionalClaimDetail'])), ''),
    bicyclePackOptionalClaimDetail: mapWithDefault(stepOtherStarrState, () => toJs(stepOtherStarrState.getIn(['form', 'bicyclePackOptionalClaimDetail'])), ''),
    personalLiabilitiesExpensesClaimed: mapWithDefault(stepOtherStarrState, () => toJs(stepOtherStarrState.getIn(['form', 'personalLiabilitiesExpensesClaimed'])), ''),
    golfPackOptionalExpensesClaimed: mapWithDefault(stepOtherStarrState, () => toJs(stepOtherStarrState.getIn(['form', 'golfPackOptionalExpensesClaimed'])), ''),
    bicyclePackOptionalExpensesClaimed: mapWithDefault(stepOtherStarrState, () => toJs(stepOtherStarrState.getIn(['form', 'bicyclePackOptionalExpensesClaimed'])), ''),
    anythingElse: mapWithDefault(stepOtherStarrState, () => toJs(stepOtherStarrState.getIn(['form', 'anythingElse'])), ''),
    anythingElseExpensesClaimed: mapWithDefault(stepOtherStarrState, () => toJs(stepOtherStarrState.getIn(['form', 'anythingElseExpensesClaimed'])), ''),
    // AD&D
    nameOfDeceased: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'nameOfDeceased']),
      ''
    ),

    dateOfInjury: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'dateOfInjury']),
      ''
    ),
    theClaimIsBeingMadeUnder: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'theClaimIsBeingMadeUnder']),
      ''
    ),
    placeWhereAccidentHappened: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'placeWhereAccidentHappened']),
      ''
    ),
    describeWhereTheAccidentOccurred: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'describeWhereTheAccidentOccurred']),
      ''
    ),
    describeHowTheAccidentOccurred: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'describeHowTheAccidentOccurred']),
      ''
    ),
    checkNameOfDeceased: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'checkNameOfDeceased']),
      ''
    ),
    // RepatriationExpenses
    assistance: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'assistance']),
      ''
    ),

    dateApproved: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'dateApproved']),
      ''
    ),

    causeOfDeath: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'causeOfDeath']),
      ''
    ),

    dateOfDeath: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'dateOfDeath']),
      ''
    ),

    stateOfDeath: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'stateOfDeath']),
      ''
    ),

    countryOfDeath: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'countryOfDeath']),
      ''
    ),

    wasTheMemberHospitalized: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'wasTheMemberHospitalized']),
      ''
    ),

    fromDate: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'fromDate']),
      ''
    ),

    toDate: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'toDate']),
      ''
    ),

    nameOfFuneralServiceProvider: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'nameOfFuneralServiceProvider']),
      ''
    ),

    costOfLocalBurial: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'costOfLocalBurial']),
      ''
    ),

    invoice: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'invoice']),
      ''
    ),

    amountClaimed: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'amountClaimed']),
      ''
    ),

    amountClaimedCurrency: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'amountClaimedCurrency']),
      ''
    ),

    costOfLocalBurialCurrency: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'costOfLocalBurialCurrency']),
      ''
    ),

    familyMemberProvidingInformation: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'familyMemberProvidingInformation']),
      ''
    ),

    relationshipToMember: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'relationshipToMember']),
      ''
    ),

    address: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'address']),
      ''
    ),

    cityOrTown: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'cityOrTown']),
      ''
    ),

    country: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'country']),
      ''
    ),

    postalCode: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'postalCode']),
      ''
    ),

    phoneNumber: mapWithDefault(
      stepOtherStarrState,
      () => stepOtherStarrState.getIn(['form', 'phoneNumber']),
      ''
    ),
    // BurialExpenses
    assistanceForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'assistanceForBurial']), ''),
    dateApprovedForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'dateApprovedForBurial']), ''),
    causeOfDeathForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'causeOfDeathForBurial']), ''),
    dateOfDeathForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'dateOfDeathForBurial']), ''),
    stateOfDeathForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'stateOfDeathForBurial']), ''),
    countryOfDeathForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'countryOfDeathForBurial']), ''),
    wasTheMemberHospitalizedForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'wasTheMemberHospitalizedForBurial']), ''),
    fromDateForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'fromDateForBurial']), ''),
    toDateForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'toDateForBurial']), ''),
    nameOfFuneralServiceProviderForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'nameOfFuneralServiceProviderForBurial']), ''),
    costOfLocalBurialForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'costOfLocalBurialForBurial']), ''),
    invoiceForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'invoiceForBurial']), ''),
    amountClaimedForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'amountClaimedForBurial']), ''),
    costOfLocalBurialCurrencyForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'costOfLocalBurialCurrencyForBurial']), ''),
    amountClaimedCurrencyForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'amountClaimedCurrencyForBurial']), ''),
    familyMemberProvidingInformationForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'familyMemberProvidingInformationForBurial']), ''),
    relationshipToMemberForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'relationshipToMemberForBurial']), ''),
    addressForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'addressForBurial']), ''),
    cityOrTownForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'cityOrTownForBurial']), ''),
    countryForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'countryForBurial']), ''),
    postalCodeForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'postalCodeForBurial']), ''),
    phoneNumberForBurial: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'phoneNumberForBurial']), ''),
    // Other Starr
    infoADAndDItems: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'infoADAndDItems']) && stepOtherStarrState.getIn(['form', 'infoADAndDItems']).toJS(), ''),
    infoRepatriationExpensesItems: mapWithDefault(stepOtherStarrState, () => stepOtherStarrState.getIn(['form', 'infoRepatriationExpensesItems']) && stepOtherStarrState.getIn(['form', 'infoRepatriationExpensesItems']).toJS(), ''),
  })
);

const makeSelectStepOtherStarrErrors = () =>
  createSelector(selectStepOtherStarr, (state) => state.get('errors'));

export {
  makeSelectStepOtherStarr,
  makeSelectStepOtherStarrErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepOther/selectors.js